import { http } from '../../config/axios'

export default function getRegistroPrincipal(documento:string, contrato:string) :Promise<any>{
    return http.get('/api/registro/registroprincipal/' + documento + '/' + contrato )
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
        console.error('Erro ao getRegistroPrincipal')
        return new Blob()
    })
}